import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WeatherCoordinates, WeatherDailyRequest, WeatherDailyResponse } from 'src/app/models/weather.model';
import { DateFormatService } from 'src/app/services/dateFormat.service';
import { WEATHER_DAILY_ENDPOINT } from 'src/app/shared/constants/weather.constants';
import nameOf from 'src/app/shared/form/nameOf.helper';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class WeatherService {
  constructor(
    private readonly http: HttpClient,
    private readonly dateFormatService: DateFormatService
  ) { }

  toRequestDate(date: Date): string {
    return this.dateFormatService.formatDateTimeToString(date, this.dateFormatService.canonicalDateFormat);
  }

  getDaily(coordinates: WeatherCoordinates, startDate: Date, endDate?: Date): Observable<WeatherDailyResponse> {
    let params = new HttpParams()
      .set(nameOf<WeatherDailyRequest>(x => x.latitude), coordinates.latitude)
      .set(nameOf<WeatherDailyRequest>(x => x.longitude), coordinates.longitude)
      .set(nameOf<WeatherDailyRequest>(x => x.startDate), this.toRequestDate(startDate));
    if (endDate) {
      params = params.set(nameOf<WeatherDailyRequest>(x => x.endDate), this.toRequestDate(endDate));
    }
    return this.http.get<WeatherDailyResponse>(`${environment.apiUrl}/${WEATHER_DAILY_ENDPOINT}`, { params });
  }
}
